import { render } from "./Meals.vue?vue&type=template&id=2e582019&scoped=true"
import script from "./Meals.vue?vue&type=script&lang=js"
export * from "./Meals.vue?vue&type=script&lang=js"

import "./Meals.vue?vue&type=style&index=0&id=2e582019&scoped=true&lang=css"

import exportComponent from "/sv-shops-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e582019"]])

export default __exports__